export interface MedikeiChronicCondition {
  id: string;
  name: string;
  controlled?: boolean | null;
  notes?: string | null;
}

export const MEMED_CONDITION_IDS = {
  AERONAUTA: 1,
  ATLETA: 2,
  GESTANTE: 3,
  LACTANTE: 4,
} as const;

export type MemedConditionId = (typeof MEMED_CONDITION_IDS)[keyof typeof MEMED_CONDITION_IDS];

const CONDITION_NAME_TO_ID: Record<string, MemedConditionId> = {
  aeronauta: MEMED_CONDITION_IDS.AERONAUTA,
  atleta: MEMED_CONDITION_IDS.ATLETA,
  gestante: MEMED_CONDITION_IDS.GESTANTE,
  lactante: MEMED_CONDITION_IDS.LACTANTE,
};

function normalizeName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function mapClinicalConditionToMemed(condition: MedikeiChronicCondition | null | undefined): MemedConditionId | null {
  if (!condition || typeof condition.name !== 'string') {
    return null;
  }

  const normalized = normalizeName(condition.name);
  if (!normalized) {
    return null;
  }

  return CONDITION_NAME_TO_ID[normalized] ?? null;
}

export function mapClinicalConditionsToMemed(conditions: MedikeiChronicCondition[] = []): MemedConditionId[] {
  const ids = new Set<MemedConditionId>();

  for (const condition of conditions) {
    const id = mapClinicalConditionToMemed(condition);
    if (id !== null) {
      ids.add(id);
    }
  }

  return Array.from(ids).sort((a, b) => a - b);
}
